import { render } from "./karir-baca.vue?vue&type=template&id=41c04769&scoped=true"
import script from "./karir-baca.vue?vue&type=script&lang=js"
export * from "./karir-baca.vue?vue&type=script&lang=js"

import "./karir-baca.vue?vue&type=style&index=0&id=41c04769&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c04769"]])

export default __exports__